import { Link } from "@tanstack/react-router";
import { Section } from "@/components/Section";
import { WhatsAppActions } from "@/components/WhatsAppActions";
import { trackCtaClick } from "@/lib/analytics";
import { useHomepageContent } from "@/hooks/useHomepageContent";
import { CmsCtaLink } from "@/components/CmsCtaLink";
import { HOMEPAGE_FALLBACKS } from "@/lib/homepage-defaults";
import { useImageFallback } from "@/hooks/useImageFallback";

export function FinalCta() {
  const content = useHomepageContent();
  const bg = useImageFallback(HOMEPAGE_FALLBACKS.finalCtaBackgroundUrl);
  return (
    <Section className="pb-24">
      <div className="relative overflow-hidden rounded-[2rem] bg-primary px-10 py-20 text-primary-foreground md:px-16 md:py-28">
        {/* Background photograph — sits under the gradient washes and overlay
            so heading/body copy stays readable against any image. */}
        <img
          src={content.finalCtaBackgroundUrl}
          alt=""
          aria-hidden
          width={1920}
          height={1080}
          loading="lazy"
          decoding="async"
          onError={bg.onError}
          className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-30"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-primary/80"
        />
        {/* Ambient gradient wash using existing tokens */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,color-mix(in_oklab,var(--accent)_35%,transparent),transparent_60%)]"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,color-mix(in_oklab,var(--primary-foreground)_10%,transparent),transparent_55%)]"
        />
        <div className="relative max-w-2xl">
          <div className="mb-4 h-px w-10 bg-primary-foreground/50" aria-hidden />
          <span className="text-xs uppercase tracking-[0.2em] text-primary-foreground/80">Get started</span>
          <h2 className="mt-4 font-display text-4xl font-medium leading-tight md:text-6xl">
            {content.ctaHeading}
          </h2>
          <p className="mt-5 max-w-xl text-primary-foreground/90">
            {content.ctaDescription}
          </p>
          <WhatsAppActions
            className="mt-10"
            location="final-cta"
            tone="dark"
            chatLabel="Order on WhatsApp"
          />
          <div className="mt-4 flex flex-wrap gap-3">
            <CmsCtaLink
              href={content.ctaButtonLink}
              onClick={() =>
                trackCtaClick({ action: "view_meal_plans", location: "final-cta", href: content.ctaButtonLink })
              }
              className="inline-flex items-center rounded-full border border-primary-foreground/40 bg-primary-foreground/5 px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary-foreground/10"
            >
              {content.ctaButtonText}
            </CmsCtaLink>
            <Link
              to="/contact"
              onClick={() =>
                trackCtaClick({ action: "contact", location: "final-cta", href: "/contact" })
              }
              className="inline-flex items-center rounded-full px-6 py-3 text-sm font-medium text-primary-foreground/90 transition-colors hover:text-primary-foreground"
            >
              Contact Us →
            </Link>
          </div>
        </div>
      </div>
    </Section>
  );
}